import React from 'react';

export const HelpTextExpandedContext = React.createContext(false);
